/* eslint-disable react/jsx-no-target-blank */
import React from 'react';
import * as yup from 'yup';
import { Formik } from 'formik';
import { Button } from '@mui/material';
import KycInput from '../kycInput';
import UploadImage from '../uploadFile';

const CompanyInformation = ({
  kybData,
  setKybData,
  handleUploadClick,
  activeStep,
  handleNext,
  handlePrevious,
  articlesOfIncorporationProgress,
  businessLicenseProgress,
  societyPatentProgress,
  rTUProgress,
}) => {
  const checkoutSchema = yup.object().shape({
    businessReason: yup.string().required('Requerido'),
    articlesOfIncorporation: yup.string().required('Requerido'),
    businessLicense: yup.string().required('Requerido'),
    societyPatent: yup.string().required('Requerido'),
    RTU: yup.string().required('Requerido'),
  });
  const handleFormSubmit = async (values) => {
    handleNext(values);
  };
  return (
    <Formik
      onSubmit={handleFormSubmit}
      initialValues={kybData}
      validationSchema={checkoutSchema}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        setFieldValue,
        setTouched,
      }) => (
        <form onSubmit={handleSubmit}>
          <>
            <KycInput
              error={touched.businessReason && errors.businessReason}
              type="text"
              name="businessReason"
              value={values.businessReason}
              handleField={handleChange}
              placeholder="Denominación o Razón Social*"
            />
            {/* articlesOfIncorporation */}
            <p className="kycForm-txt2">Acta de constitución</p>
            <UploadImage
              name="articlesOfIncorporation"
              handleUploadClick={handleUploadClick}
              text="Cargar Foto"
              setFieldValue={setFieldValue}
            />
            &nbsp; &nbsp; &nbsp;
            {articlesOfIncorporationProgress > 0 ? (
              <span>
                Cargado &nbsp;
                <span style={{ color: 'green' }}>
                  {articlesOfIncorporationProgress} %
                </span>
              </span>
            ) : null}
            {errors.articlesOfIncorporation && (
              <span style={{ color: 'red' }}>
                {errors.articlesOfIncorporation}
              </span>
            )}
            &nbsp; &nbsp; &nbsp;
            {kybData.articlesOfIncorporation && (
              <a href={kybData.articlesOfIncorporation} target="_blank">
                Visualizar
              </a>
            )}
            {/* businessLicense */}
            <p className="kycForm-txt2">Patente de comercio</p>
            <UploadImage
              name="businessLicense"
              handleUploadClick={handleUploadClick}
              text="Cargar Foto"
              setFieldValue={setFieldValue}
            />
            &nbsp; &nbsp; &nbsp;
            {businessLicenseProgress > 0 ? (
              <span>
                Cargado &nbsp;
                <span style={{ color: 'green' }}>
                  {businessLicenseProgress} %
                </span>
              </span>
            ) : null}
            {errors.businessLicense && (
              <span style={{ color: 'red' }}>{errors.businessLicense}</span>
            )}
            &nbsp; &nbsp; &nbsp;
            {kybData.businessLicense && (
              <a href={kybData.businessLicense} target="_blank">
                Visualizar
              </a>
            )}
            {/* societyPatent */}
            <p className="kycForm-txt2">Patente de sociedad (Opcional si es SA)</p>
            <UploadImage
              name="societyPatent"
              handleUploadClick={handleUploadClick}
              text="Cargar Foto"
              setFieldValue={setFieldValue}
            />
            &nbsp; &nbsp; &nbsp;
            {societyPatentProgress > 0 ? (
              <span>
                Cargado &nbsp;
                <span style={{ color: 'green' }}>
                  {societyPatentProgress} %
                </span>
              </span>
            ) : null}
            {errors.societyPatent && (
              <span style={{ color: 'red' }}>{errors.societyPatent}</span>
            )}
            &nbsp; &nbsp; &nbsp;
            {kybData.societyPatent && (
              <a href={kybData.societyPatent} target="_blank">
                Visualizar
              </a>
            )}
            {/* RTU */}
            <p className="kycForm-txt2">RTU</p>
            <UploadImage
              name="RTU"
              handleUploadClick={handleUploadClick}
              text="Cargar Foto"
              setFieldValue={setFieldValue}
            />
            &nbsp; &nbsp; &nbsp;
            {rTUProgress > 0 ? (
              <span>
                Cargado &nbsp;
                <span style={{ color: 'green' }}>{rTUProgress} %</span>
              </span>
            ) : null}
            {errors.RTU && <span style={{ color: 'red' }}>{errors.RTU}</span>}
            &nbsp; &nbsp; &nbsp;
            {kybData.RTU && (
              <a href={kybData.RTU} target="_blank">
                Visualizar
              </a>
            )}
          </>
          <div className="stepperkycForm-enter-btn">
            <Button
              variant="contained"
              onClick={() => handlePrevious(values)}
              disabled={activeStep === 0}
            >
              Anterior
            </Button>
            <Button type="submit" variant="contained">
              Siguiente
            </Button>
          </div>
        </form>
      )}
    </Formik>
  );
};

export default CompanyInformation;
